import { Box } from '@talos/kyoko';
import styled from 'styled-components';

export const BlotterWrapper = styled(Box)``;

BlotterWrapper.defaultProps = {
  w: '100%',
  h: '100%',
};
